module.exports = __webpack_public_path__ + "img/01-Abito-LAGRAIN-SML--STAMPE-LINO--UNITI-LINO2.a281bdf6.jpg";